import { ProvisionItem } from './provisionitem';
import { ProvisionChange } from './provisionchange';
import { ProvisionContent } from './provisioncontent';

export class Provision {
  
  Name: string;
  PDVersion: string;  
  Provision: Array<ProvisionItem> = new Array<ProvisionItem>();
  Changes : Array<ProvisionChange> = new Array<ProvisionChange>();

  constructor() {       

  }

  static fromOAS(data: any) : Provision{
    let provision = new Provision();  
    if(data != null){
      let provisionDataRows = data["rows"][0]["rows"].filter(row => row["type"] == "part_period");
      if(provisionDataRows.length>0){
        provision.PDVersion=provisionDataRows[0]["values"][0]["value"];
      }
      provision.Provision = data["rows"][0]["blobs"][0]["blobdata"]["provision"]["items"].map(provision => {
        return ProvisionItem.fromOAS(provision);
      });
      provision.Name = data["rows"][0]["values"][0].value;
    }

    provision.Provision.sort((a,b) => (parseInt(a.Family) > parseInt(b.Family)) ? 1 : ((parseInt(b.Family) > parseInt(a.Family)) ? -1 : 0)); 
    return provision;
  }

  static fromContent(name: string, content: ProvisionContent): Provision {
    if (!content || typeof content.EntityTag !== 'string' || !content.EntityTag ||
        !Array.isArray(content.FpcValues) || !name ||
        (content.ProvisionName !== undefined &&
          (typeof content.ProvisionName !== 'string' || !content.ProvisionName))) {
      throw new Error('Invalid provision content response');
    }

    const provision = new Provision();
    provision.Name = content.ProvisionName ?? name;
    if (content.Details) {
      if ((content.Details.PartPeriod !== null && typeof content.Details.PartPeriod !== 'string')
          || !Array.isArray(content.Details.Descriptions)
          || content.Details.Descriptions.some(item =>
            typeof item?.FpcType !== 'string' || typeof item.FpcValue !== 'string'
            || typeof item.FamilyDescription !== 'string' || typeof item.ExecutionDescription !== 'string')) {
        throw new Error('Invalid provision details response');
      }
      provision.PDVersion = content.Details.PartPeriod || undefined;
    }
    const descriptions = new Map(content.Details?.Descriptions.map(item =>
      [`${item.FpcType.toLowerCase()}:${item.FpcValue}`, item] as const
    ) || []);
    provision.Provision = content.FpcValues.map(row => {
      const family = typeof row?.FpcType === 'string' && /^fpc(\d+)$/i.exec(row.FpcType);
      if (!family || typeof row.FpcValue !== 'string') {
        throw new Error('Invalid FPC in provision content response');
      }
      const description = descriptions.get(`${row.FpcType.toLowerCase()}:${row.FpcValue}`);
      return new ProvisionItem('FPC', family[1], description?.FamilyDescription,
        row.FpcValue, description?.ExecutionDescription, false);
    });
    provision.Provision.sort((a, b) => Number(a.Family) - Number(b.Family));
    return provision;
  }
  
  
}
